import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { APP_WEB_VERSION } from '../utils/appVersion';

type AppWebVersionCaptionProps = {
  /** authFooter: pie global de auth (junto copyright/enlaces). Drawer: pie del menú lateral. */
  placement: 'authFooter' | 'drawer';
  drawerOpen?: boolean;
};

export default function AppWebVersionCaption({ placement, drawerOpen = true }: AppWebVersionCaptionProps) {
  if (placement === 'authFooter') {
    return (
      <Typography
        variant="caption"
        color="secondary"
        component="span"
        sx={{
          opacity: 0.75,
          letterSpacing: 0.02,
          whiteSpace: 'nowrap',
          userSelect: 'none'
        }}
        aria-label={APP_WEB_VERSION}
        title={APP_WEB_VERSION}
      >
        {APP_WEB_VERSION}
      </Typography>
    );
  }

  if (!drawerOpen) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 'auto',
        flexShrink: 0,
        py: 1.5,
        px: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      aria-label={APP_WEB_VERSION}
      title={APP_WEB_VERSION}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          m: 0,
          textAlign: 'center',
          lineHeight: 1.2,
          wordBreak: 'break-all'
        }}
        component="p"
      >
        {APP_WEB_VERSION}
      </Typography>
    </Box>
  );
}
